
export default {
  data () {
    return {
      wizardStateSnapshot: null,
      wizardLinksSnapshot: null,
      wizardLeaveNext: null,
      modalLeaveOpen: false
    }
  },

  computed: {
    hasUnsavedChanges () {
      return this.wizardStateSnapshot !== null && this.wizardStateSnapshot !== this.serializeWizardState()
    },

    hasLinkedChanges () {
      return this.wizardLinksSnapshot !== null && this.wizardLinksSnapshot !== this.serializeWizardLinks()
    }
  },

  mounted () {
    window.addEventListener('beforeunload', this.wizardHandleBeforeUnload)
  },

  beforeDestroy () {
    window.removeEventListener('beforeunload', this.wizardHandleBeforeUnload)
  },

  beforeRouteLeave (to, from, next) {
    if (!this.hasUnsavedChanges) {
      next()

      return
    }

    this.wizardLeaveNext = next
    this.modalLeaveOpen = true
  },

  methods: {
    wizardTrackedState () {
      return { formData: this.formData }
    },

    serializeWizardState () {
      return JSON.stringify(this.wizardTrackedState())
    },

    wizardLinkedState () {
      return null
    },

    serializeWizardLinks () {
      return JSON.stringify(this.wizardLinkedState())
    },

    snapshotWizardState () {
      this.wizardStateSnapshot = this.serializeWizardState()
      this.wizardLinksSnapshot = this.serializeWizardLinks()
    },

    confirmWizardLeave () {
      const next = this.wizardLeaveNext

      this.modalLeaveOpen = false
      this.wizardLeaveNext = null

      if (next) next()
    },

    cancelWizardLeave () {
      const next = this.wizardLeaveNext

      this.modalLeaveOpen = false
      this.wizardLeaveNext = null

      if (next) next(false)
    },

    wizardHandleBeforeUnload (event) {
      if (!this.hasUnsavedChanges) return

      event.preventDefault()
      event.returnValue = ''
    },

    getValidationFieldsByTab () {
      return {}
    },

    validateActiveTab () {
      const validations = this.getValidationFieldsByTab()[this.activeTab] || []

      validations.forEach(validation => {
        if (validation && typeof validation.$touch === 'function') {
          validation.$touch()
        }
      })

      return !validations.some(validation => validation && validation.$invalid)
    },

    getFirstInvalidTab () {
      const validationsByTab = this.getValidationFieldsByTab()
      const invalidTab = Object.keys(validationsByTab)
        .find(tab => {
          return validationsByTab[tab].some(validation => validation && validation.$invalid)
        })

      return invalidTab ? Number(invalidTab) : null
    }
  }
}
